module.exports = __webpack_public_path__ + "static/img/n2_10.2f47e37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n2_10.jpg
// module id = Zxf1
// module chunks = 2